/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Features_Api_AccessInputs */

const es_components_upgrade_plan_modal_features_api_access = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_Api_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acceso a API incluido`)
};

const en_components_upgrade_plan_modal_features_api_access = /** @type {(inputs: Components_Upgrade_Plan_Modal_Features_Api_AccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API access included`)
};

/**
* | output |
* | --- |
* | "API access included" |
*
* @param {Components_Upgrade_Plan_Modal_Features_Api_AccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_features_api_access = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Features_Api_AccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Features_Api_AccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_features_api_access(inputs)
	return en_components_upgrade_plan_modal_features_api_access(inputs)
});
export { components_upgrade_plan_modal_features_api_access as "components.upgrade_plan_modal.features.api_access" }